export default __webpack_public_path__ + "66666a2c7ce3d49491534f90d1f9a16a.png";